var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'cf-component-link';
import DropdownRegistry from './DropdownRegistry';

var DropdownLink = function (_React$Component) {
  _inherits(DropdownLink, _React$Component);

  function DropdownLink(props, context) {
    _classCallCheck(this, DropdownLink);

    if (!props.to && !props.onClick) {
      throw new Error('<DropdownLink/> requires either a `to` or `onClick` prop');
    }

    var _this = _possibleConstructorReturn(this, (DropdownLink.__proto__ || Object.getPrototypeOf(DropdownLink)).call(this, props, context));

    _this.dropdownRegistry = context.dropdownRegistry;

    _this.handleLinkBlur = _this.handleLinkBlur.bind(_this);
    _this.handleLinkFocus = _this.handleLinkFocus.bind(_this);
    _this.focus = _this.focus.bind(_this);
    return _this;
  }

  _createClass(DropdownLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.dropdownRegistry.addChild(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.dropdownRegistry.removeChild(this);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.link.focus();
    }
  }, {
    key: 'handleLinkFocus',
    value: function handleLinkFocus() {
      this.dropdownRegistry.setFocusedChild(this);
    }
  }, {
    key: 'handleLinkBlur',
    value: function handleLinkBlur() {
      this.dropdownRegistry.removeFocusedChild();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'li',
        { className: 'cf-dropdown__link', role: 'menuitem' },
        React.createElement(
          Link,
          {
            ref: function ref(node) {
              return _this2.link = node;
            },
            to: this.props.to,
            onClick: this.props.onClick,
            onFocus: this.handleLinkFocus,
            onBlur: this.handleLinkBlur
          },
          this.props.children
        )
      );
    }
  }]);

  return DropdownLink;
}(React.Component);

DropdownLink.propTypes = {
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

DropdownLink.contextTypes = {
  dropdownRegistry: PropTypes.instanceOf(DropdownRegistry).isRequired
};

export default DropdownLink;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-dropdown/es/DropdownLink.js
// module id = 956
// module chunks = 0